module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("My Orders")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.orders), function(order) {
    return _c('tr', [_c('td', [_vm._v("#" + _vm._s(order.order_number))]), _vm._v(" "), _c('td', [_vm._v("£ " + _vm._s(parseFloat(order.sub_total).toFixed(2)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.discount_type) + " " + _vm._s(order.discount))]), _vm._v(" "), _c('td', [_vm._v("£" + _vm._s(parseFloat(order.shipping_price).toFixed(2)))]), _vm._v(" "), _c('td', [_vm._v("£" + _vm._s(parseFloat(order.admin_fee).toFixed(2)))]), _vm._v(" "), _c('td', [_vm._v("£" + _vm._s(parseFloat(order.total).toFixed(2)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(order.status))]), _vm._v(" "), _c('td', {
      staticClass: "text-capitalize"
    }, [_vm._v(_vm._s(order.type))]), _vm._v(" "), _c('td', {
      staticClass: "text-capitalize"
    }, [_vm._v(_vm._s(_vm.getLocation(order.location_id).name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(order.created_at)))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "btn btn-primary btn-xs",
      on: {
        "click": function($event) {
          return _vm.view(order)
        }
      }
    }, [_vm._v("View Details")]), _vm._v(" "), _c('div', {
      staticClass: "btn btn-danger btn-xs",
      on: {
        "click": function($event) {
          return _vm.reorder(order)
        }
      }
    }, [_vm._v("Reorder")])])])
  }), _vm._v(" "), (!_vm.orders) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "9"
    }
  }, [_vm._v("You have no orders")])]) : _vm._e()], 2)])])])]), _vm._v(" "), _c('div', {
    class: ['order-box', (_vm.showOrderBox !== null ? (_vm.showOrderBox ? 'animated fadeIn' : 'animated fadeOut') : 'not-displayed')]
  }, [_c('div', {
    staticClass: "order-content"
  }, [_c('div', {
    staticClass: "close",
    on: {
      "click": _vm.closePopup
    }
  }, [_vm._v("×")]), _vm._v(" "), (!_vm.boxOrder) ? _c('div', {
    staticClass: "text-center pt-2 pb-2"
  }, [_vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.boxOrder) ? _c('div', {
    staticClass: "order-details"
  }, [_c('h3', [_vm._v("Order #" + _vm._s(_vm.boxOrder.order_number))]), _vm._v(" "), _c('h5', [_vm._v("Order placed at " + _vm._s(_vm.formatDate(_vm.boxOrder.created_at)))]), _vm._v(" "), _vm._l((_vm.boxOrder.items), function(product) {
    return _c('div', [(product.type == 'product') ? _c('div', {
      staticClass: "order-box-product"
    }, [_c('div', {
      staticClass: "product_title pull-left"
    }, [_vm._v("\n              " + _vm._s(product.quantity) + " x\n              " + _vm._s(product.title) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "product_price pull-right"
    }, [(product.discount > 0) ? _c('span', [_c('strike', [_vm._v("£ " + _vm._s(parseFloat(product.price).toFixed(2)))]), _vm._v("\n              £ " + _vm._s(parseFloat(product.discount).toFixed(2)) + "\n            ")], 1) : _c('span', [_vm._v("£ " + _vm._s(parseFloat(product.price).toFixed(2)))])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]) : _vm._e(), _vm._v(" "), (product.type == 'offer') ? _c('div', {
      staticClass: "order-box-product"
    }, [_c('div', {
      staticClass: "product_title pull-left"
    }, [_vm._v("\n              " + _vm._s(product.quantity) + " x\n              " + _vm._s(product.title) + "\n              "), _c('div', {
      staticClass: "offer-items"
    }, _vm._l((product.categorized_items), function(items, categoryTitle) {
      return _c('div', [_c('div', {
        staticClass: "offer-category"
      }, [_vm._v(_vm._s(categoryTitle))]), _vm._v(" "), _vm._l((items), function(item) {
        return _c('div', {
          staticClass: "offer-item"
        }, [_vm._v("\n                    " + _vm._s(item.product_title) + "\n                  ")])
      })], 2)
    }), 0)]), _vm._v(" "), _c('div', {
      staticClass: "product_price pull-right"
    }, [(product.discount > 0) ? _c('span', [_c('strike', [_vm._v("£ " + _vm._s(parseFloat(product.price).toFixed(2)))]), _vm._v("\n              £ " + _vm._s(parseFloat(product.discount).toFixed(2)) + "\n            ")], 1) : _c('span', [_vm._v("£ " + _vm._s(parseFloat(product.price).toFixed(2)))])]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "box-order-details"
  }, [_c('div', {
    staticClass: "order-detail"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_vm._v("Type")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right text-capitalize"
  }, [_vm._v(_vm._s(_vm.boxOrder.type))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), _c('div', {
    staticClass: "order-detail"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_vm._v("Subtotal")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_vm._v("£" + _vm._s(parseFloat(_vm.boxOrder.sub_total).toFixed(2)))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), (_vm.boxOrder.discount) ? _c('div', {
    staticClass: "order-detail"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_vm._v("Discount")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.boxOrder.discount) + " " + _vm._s(_vm.boxOrder.discount_type))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e(), _vm._v(" "), (_vm.boxOrder.type == 'delivery') ? _c('div', {
    staticClass: "order-detail"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_vm._v("Shipping")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_vm._v("£" + _vm._s(parseFloat(_vm.boxOrder.shipping_price).toFixed(2)))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e(), _vm._v(" "), (_vm.boxOrder.type == 'delivery' && _vm.boxOrder.delivery_address) ? _c('div', {
    staticClass: "order-detail"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_vm._v("Delivered to")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right text-right"
  }, [_vm._v(_vm._s(_vm.boxOrder.delivery_address))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e(), _vm._v(" "), (_vm.boxOrder.type == 'delivery' && _vm.boxOrder.delivery_postcode) ? _c('div', {
    staticClass: "order-detail"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_vm._v("Postcode")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.boxOrder.delivery_postcode))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e(), _vm._v(" "), (_vm.paymentSourceLabel(_vm.boxOrder)) ? _c('div', {
    staticClass: "order-detail"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_vm._v("Paid with")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right text-right"
  }, [_vm._v(_vm._s(_vm.paymentSourceLabel(_vm.boxOrder)))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "order-detail"
  }, [_c('div', {
    staticClass: "pull-left"
  }, [_vm._v("Total")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_vm._v("£" + _vm._s(parseFloat(_vm.boxOrder.total).toFixed(2)))]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "btn btn-danger mb-3",
    on: {
      "click": function($event) {
        return _vm.reorder(_vm.boxOrder)
      }
    }
  }, [_vm._v("Reorder")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Order No.")]), _vm._v(" "), _c('th', [_vm._v("Subtotal, £")]), _vm._v(" "), _c('th', [_vm._v("Discount, %")]), _vm._v(" "), _c('th', [_vm._v("Shipping, £")]), _vm._v(" "), _c('th', [_vm._v("Admin Fee, £")]), _vm._v(" "), _c('th', [_vm._v("Total, £")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Location")]), _vm._v(" "), _c('th', [_vm._v("Ordered at")]), _vm._v(" "), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader-1"
  }, [_c('span')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-054cefb8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/profile/my-orders.vue
// module id = 542
// module chunks = 1